import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginPage = _resolveComponent("LoginPage")!
  const _component_Thongkedoanhthu = _resolveComponent("Thongkedoanhthu")!
  const _component_Thongkebennhan = _resolveComponent("Thongkebennhan")!

  return (!$setup.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoginPage)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        ($setup.permission='ketoan')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Thongkedoanhthu)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Thongkebennhan)
            ]))
      ]))
}